"use strict";
"use client";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JumpToLatestButton = JumpToLatestButton;
var _materialSymbols = require("@design/icons/material-symbols");
var _button = require("@design/ui/button");
var _jsxRuntime = require("react/jsx-runtime");
function JumpToLatestButton(_ref) {
  var onJumpToLatest = _ref.onJumpToLatest;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "absolute bottom-3 left-1/2 -translate-x-1/2 z-10",
    "data-sentry-component": "JumpToLatestButton",
    "data-sentry-source-file": "JumpToLatestButton.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_button.Button, {
      type: "button",
      variant: "outline",
      size: "xs",
      onClick: onJumpToLatest,
      "data-sentry-element": "Button",
      "data-sentry-source-file": "JumpToLatestButton.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ArrowDownwardIcon, {
        "data-icon": "inline-start",
        "data-sentry-element": "ArrowDownwardIcon",
        "data-sentry-source-file": "JumpToLatestButton.tsx"
      }), "Jump to latest"]
    })
  });
}